<template>
    <div
        v-if="isPageLoaded"
        class="partner-with-us-school"
    >
        <div class="hero-banner">
            <div class="container text-center white--text">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-13"
                >
                    <v-col cols="12" lg="9" class="pa-lg-0">
                        <h1 v-html="page.pageTitle"></h1>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-10"
                >
                    <v-col cols="10" sm="8" md="7" lg="6" class="pa-lg-0">
                        <p v-html="page.pageSubtitle"></p>
                    </v-col>
                </v-row>

                <v-row class="ma-0 mb-2 mb-md-6">
                    <v-col class="d-flex justify-center pa-lg-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToCallToAction"
                        >
                            <span>Join Now</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="about-section section">
            <div class="content">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-12"
                >
                    <v-col cols="12" lg="7" class="pa-lg-0">
                        <h2>{{ page.aboutTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-12"
                >
                    <v-col cols="12" sm="11" md="8" lg="7" class="pa-lg-0">
                        <p>{{ page.aboutContent }}</p>
                    </v-col>
                </v-row>

                <v-row
                    v-for="(aboutBlock, index) in page.aboutBlocks"
                    :key="`about-block-${aboutBlock.id}`"
                    class="about-block ma-0 mb-8 mb-lg-12"
                    :class="(index % 2 === 1 ? 'flex-row-reverse' : '')"
                >
                    <v-col cols="12" sm="10" md="6" class="about-text pa-lg-0">
                        <h4>{{ aboutBlock.title }}</h4>
                        <p>
                            {{ aboutBlock.content }}
                            <template v-if="aboutBlock?.content2?.length > 0">
                                <br><br>
                                {{ aboutBlock.content2 }}
                            </template>
                        </p>
                    </v-col>
                    <v-col cols="12" sm="10" md="6" class="about-image pa-lg-0">
                        <img
                            :src="getImageUrl(aboutBlock.image)"
                            :alt="aboutBlock.image.alternativeText"
                        >
                    </v-col>
                </v-row>

                <v-row class="ma-0 mb-2 mb-md-6">
                    <v-col class="d-flex justify-center pa-lg-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToCallToAction"
                        >
                            <span>Join Now</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="steps-section section section-dark">
            <div class="content">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8"
                >
                    <v-col cols="12" lg="7" class="pa-lg-0">
                        <h2>{{ page.stepsTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-8 mb-lg-12"
                >
                    <v-col cols="12" sm="10" md="8" class="px-lg-5">
                        <p>{{ page.stepsContent }}</p>
                    </v-col>
                </v-row>

                <v-row
                    v-for="(step, index) in page.steps"
                    :key="`step-block-${step.id}`"
                    justify="center"
                    class="step-block ma-0 mb-8 mb-lg-12"
                    :class="(index % 2 === 1 ? 'flex-row-reverse' : '')"
                >
                    <v-col cols="12" sm="10" md="4" lg="3" class="step-content pa-lg-0">
                        <div class="content-container">
                            <div class="content-line"></div>
                            <p>{{ step.content }}</p>
                            <div class="step-avatar">
                                <v-avatar color="primary" size="54" class="elevation-6">
                                    <span class="white--text font-weight-bold">{{ (index + 1) }}</span>
                                </v-avatar>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="10" md="8" lg="6" class="step-image pa-lg-0">
                        <img
                            :src="getImageUrl(step.image)"
                            :alt="step.image.alternativeText"
                        >
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>
            </div>
        </div>

        <div class="testimonials-section section">
            <div class="content">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-12"
                >
                    <v-col cols="12" lg="7" class="pa-lg-0">
                        <h3>{{ page.testimonialTitle }}</h3>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="school-carousel ma-0 mb-4 mb-md-12"
                >
                    <SchoolLogoMarquee
                        :logos="schoolLogos"
                        :animation-speed="100"
                    />
                </v-row>

                <TestimonialsCarousel
                    v-if="testimonials"
                    :testimonials-data="testimonials"
                    class="text-left"
                />

                <v-row class="ma-0 mb-4 mb-md-8 mb-md-12">
                    <v-col class="d-flex justify-center pa-lg-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToCallToAction"
                        >
                            <span>Join Now</span>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4"
                >
                    <v-col cols="12" md="8" lg="5" class="pa-lg-0">
                        <h2>{{ page.partnerTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4"
                >
                    <v-col cols="12" sm="10" md="8">
                        <p>{{ page.partnerContent }}</p>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4"
                >
                    <SimpleSteps
                        v-if="simpleSteps"
                        page-name="partner-with-us-school"
                        :call-to-actions="simpleSteps"
                    />
                </v-row>
            </div>
        </div>

        <div id="call-to-action" class="call-to-action section section-dark">
            <div class="content my-0">
                <v-row>
                    <v-col cols="12" md="6" lg="5" class="call-to-action-content">
                        <div class="text-center text-md-left">
                            <v-row class="ma-0 mb-4">
                                <v-col cols="12" class="pa-md-0">
                                    <h2>{{ page.ctaTitle }}</h2>
                                </v-col>
                            </v-row>

                            <v-row class="ma-0">
                                <v-col cols="12"  class="ma-md-0">
                                    <p>{{ page.ctaContent }}</p>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="12" md="6">
                        <v-card
                            class="call-to-action-form"
                            outlined
                        >
                            <v-card-text>
                                <v-row class="ma-0 mt-3 mb-3">
                                    <v-col class="pa-0">
                                        <h3 class="primary--text">Become an EDUrent Partner School</h3>
                                    </v-col>
                                </v-row>

                                <form class="text-left">
                                    <v-row class="ma-0 mt-3 mb-3">
                                        <v-col class="pa-0">
                                            <label for="email-address">First Name*</label>
                                            <v-text-field
                                                v-model="contactForm.firstName"
                                                :error-messages="formErrors.name"
                                                required
                                                outlined
                                                hide-details="auto"
                                                background-color="white"
                                                name="first-name"
                                                placeholder="First Name"
                                                class="btn-edu-height"
                                                v-on:input="$v.contactForm.firstName.$touch()"
                                                v-on:blur="$v.contactForm.firstName.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row class="ma-0 mt-3 mb-3">
                                        <v-col class="pa-0">
                                            <label for="email-address">Email Address*</label>
                                            <v-text-field
                                                v-model="contactForm.emailAddress"
                                                :error-messages="formErrors.email"
                                                required
                                                outlined
                                                hide-details="auto"
                                                background-color="white"
                                                name="email-address"
                                                placeholder="Email Address"
                                                class="btn-edu-height"
                                                v-on:input="$v.contactForm.emailAddress.$touch()"
                                                v-on:blur="$v.contactForm.emailAddress.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row class="ma-0 mt-3 mb-3">
                                        <v-col class="pa-0">
                                            <label for="school-name">School*</label>
                                            <v-text-field
                                                v-model="contactForm.schoolName"
                                                :error-messages="formErrors.school"
                                                required
                                                outlined
                                                hide-details="auto"
                                                background-color="white"
                                                name="school-name"
                                                placeholder="Enter Your School Name"
                                                class="btn-edu-height"
                                                v-on:input="$v.contactForm.schoolName.$touch()"
                                                v-on:blur="$v.contactForm.schoolName.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row class="ma-0 mt-3 mb-3">
                                        <v-col class="pa-0">
                                            <label for="phone-number">Phone Number*</label>
                                            <v-text-field
                                                v-model="contactForm.phoneNumber"
                                                :error-messages="formErrors.phone"
                                                required
                                                outlined
                                                hide-details="auto"
                                                background-color="white"
                                                name="phone-number"
                                                placeholder="Enter Your Phone Number"
                                                class="btn-edu-height"
                                                v-on:input="formatPhoneNumber"
                                                v-on:blur="$v.contactForm.phoneNumber.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row class="ma-0 mt-3 mb-8">
                                        <v-col class="pa-0 privacy">
                                            <v-checkbox
                                                label="I HAVE READ AND UNDERSTOOD THE TERMS AND PRIVACY POLICY AND AGREE TO RECEIVE PERSONALIZED COMMERCIAL COMMUNICATION FROM EDURENT BY EMAIL AND SMS."
                                                class="py-0 consent-text"
                                                v-model="contactForm.allow_subscription"
                                                default="true"
                                                hide-details
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>

                                    <v-row class="ma-0 mt-3 mb-3">
                                        <v-col class="pa-0">
                                            <v-btn
                                                color="primary"
                                                block
                                                depressed
                                                class="btn-edu-height"
                                                v-on:click.prevent="submit"
                                            >
                                                <span>Submit</span>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import SchoolLogoMarquee from '@/components/SchoolLogoMarquee';
import SimpleSteps from '@/components/SimpleSteps';
import TestimonialsCarousel from '@/components/TestimonialsCarousel';
import SiteService from '@/services/site.service';
import { flattenObj, formatPhoneNumber } from '@/utils/utils';

export default {
    name: "PartnerSchool",

    components: {
        SchoolLogoMarquee,
        SimpleSteps,
        TestimonialsCarousel,
    },

    data() {
        return {
            baseMediaPath: process.env.VUE_APP_CMS_BASE_URL ?? 'https://cms.edurent.com',

            contactForm: {
                emailAddress: '',
                firstName: '',
                phoneNumber: '',
                schoolName: '',
                allow_subscription: false,
            },

            page: {
                id: null,

                pageTitle: '',
                pageSubtitle: '',

                aboutTitle: '',
                aboutContent: '',
                aboutBlocks: null,

                stepsTitle: '',
                stepsContent: '',
                steps: null,

                testimonialTitle: '',
                schoolLogos: null,
                testimonials: null,

                partnerTitle: '',
                partnerContent: '',
                partnerSteps: null,

                ctaTitle: '',
                ctaContent: '',
            },
        };
    },

    validations: {
        contactForm: {
            firstName: { required },
            emailAddress: { required, email },
            schoolName: { required },
            phoneNumber: { required },
            allow_subscription: { required },
        },
    },

    computed: {
        formErrors() {
            const errors = {
                email: [],
                name: [],
                phone: [],
                school: [],
            };

            if (! this.$v.contactForm.$anyDirty) {
                return errors;
            }

            if (this.$v.contactForm.emailAddress.$dirty) {
                ! this.$v.contactForm.emailAddress.email && errors.email.push('Must be a valid E-mail Address');
                ! this.$v.contactForm.emailAddress.required && errors.email.push('E-mail Address is required');
            }

            if (this.$v.contactForm.firstName.$dirty) {
                ! this.$v.contactForm.firstName.required && errors.name.push('First Name is required');
            }

            if (this.$v.contactForm.phoneNumber.$dirty) {
                ! this.$v.contactForm.phoneNumber.required && errors.phone.push('Phone Number is required');
            }

            if (this.$v.contactForm.schoolName.$dirty) {
                ! this.$v.contactForm.schoolName.required && errors.school.push('School Name is required');
            }

            return errors;
        },

        isPageLoaded() {
            return this.page?.id > 0;
        },

        simpleSteps() {
            if (! this.isPageLoaded || this.page.partnerSteps == null) {
                return [];
            }

            return this.page.partnerSteps.map((step) => {
                return {
                    title: step.title,
                    icon: step.image,
                    description: step.content,
                };
            });
        },

        schoolLogos() {
            if (! this.isPageLoaded || this.page.schoolLogos == null) {
                return [];
            }

            return this.page.schoolLogos?.[0]?.images || [];
        },

        testimonials() {
            if (! this.isPageLoaded || this.page.testimonials == null) {
                return [];
            }

            return this.page.testimonials.map((testimonial) => {
                return {
                    name: testimonial.author,
                    quote: testimonial.content,
                };
            });
        },
    },

    beforeMount() {
        this.init();
    },

    methods: {
        /**
         * Clear the vuelidate validation for the call to action form.
         * @returns {void}
         */
        clearForm() {
            this.$v.contactForm.$reset();
            this.contactForm.firstName = '';
            this.contactForm.emailAddress = '';
            this.contactForm.schoolName = '';
            this.contactForm.phoneNumber = '';
        },

        /**
         * Format the phone number and update the contact form validation.
         */
        formatPhoneNumber() {
            this.$v.contactForm.phoneNumber.$touch();
            this.contactForm.phoneNumber = formatPhoneNumber(this.contactForm.phoneNumber);
        },

        /**
         * Attempt to get the file path from the specified image object.
         * @param {Object} image
         * @returns {string}
         */
        getImageUrl(image) {
            try {
                return this.baseMediaPath + image.url;
            } catch (thrown) {
                return '';
            }
        },

        /**
         * Get the page data from the CMS and if the data is not available, navigate back to the default page.
         * @returns {Promise<Route|void>}
         */
        async init() {
            // Set the menu to transparent
            this.$store.commit('setHeaderMenuState', 'transparent');

            // Get the page data
            const response = await SiteService.getPartnerWithUsSchoolPage();
            if (response == null) {
                return this.$router.push('/');
            }

            // Check that the response returned the page with id, otherwise return to the homepage
            const page = flattenObj(response);
            if (page == null || page?.id == null) {
                return this.$router.push('/');
            }

            this.page = page;
        },

        /**
         * Scroll to the call-to-action section of the page.
         */
        scrollToCallToAction() {
            const offset = this.$vuetify.breakpoint.mdAndDown ? -65 : 0;

            this.$scrollTo('#call-to-action', 500, {
                offset,
            });
        },

        /**
         * Attempt to submit the call to action form.
         * @returns {void}
         */
        submit() {
            // Handle the form validation errors, if any exist
            this.$v.contactForm.$touch();
            if (this.$v.contactForm.$invalid) {
                // Scroll to the contact form, just in case
                this.scrollToCallToAction();

                // Show a snackbar message to the user about the form errors
                this.$store.commit('setSnackbar', {
                    show: true,
                    message: 'A mandatory field is missing. Please look through the '
                        + 'form and fix the field(s) highlighted in red',
                    color: 'red',
                });

                // Return without submitting the form
                return;
            }

            // The form is valid, so send the information
            this.$store.dispatch('sendEdurentPartnerMessage', {
                name: this.contactForm.firstName,
                email: this.contactForm.emailAddress,
                phone: this.contactForm.phoneNumber,
                school: this.contactForm.schoolName,
                allow_subscription: this.contactForm.allow_subscription
            }).then(() => {
                this.clearForm();
            })
        },
    },
};
</script>

<style scoped lang="scss">
/** Generic Page styles */
::v-deep .content>.row {
    width: 100%;
    margin: 0;
}

div.partner-with-us-school {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;

    .v-btn {
        height: 45px;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: normal;
        text-transform: capitalize;
        padding: 0 25px;
    }
}

div.hero-banner .container,
div.section .content {
    height: fit-content;
    width: 90%;
    max-width: 1505px;
    padding: 0 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    word-spacing: 1px;
    z-index: 2;
}

/** Hero Banner styles */
div.hero-banner {
    padding-top: 160px;
    padding-bottom: 55px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    max-height: 630px;
    min-height: 567px;
    background-image: url("../../src/assets/media/partner-school-header.jpg");
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;

    h1 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 64px;
        line-height: 72px;
        max-width: 1300px;
        margin: auto;

        @media (max-width: 1400px) {
            font-size: clamp(30px, 3em, 64px);
            line-height: 1.125;
        }

        @media (max-width: 575px) {
            font-size: 30px;
        }
    }

    &:before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(10, 10, 10, 0.75);
        z-index: 1;
    }

    @media (max-width: 1264px) {
        max-height: 720px;
        min-height: 630px;
        padding-top: 170px;
    }

    @media (max-width: 1024px) {
        padding: 0;

        h1 {
            font-size: clamp(30px, 3em, 50px);
            padding-left: 0;
            padding-right: 0;
        }
    }

    @media (max-width: 768px) {
        padding-top: 100px;
        padding-bottom: 70px;
        min-height: 200px;
        height: auto;

        h1 {
            font-size: clamp(30px, 2em, 64px);
        }
    }
}

/** Section styles */
div.section {
    font-family: 'Poppins';
    font-style: normal;
    padding: 75px 0;

    .content {
        h2, h3, h4, p {
            color: #000000;
        }

        h2 {
            font-weight: 700;
            font-size: 48px;
            line-height: 1.5;
            margin: 0 auto;
        }

        h3 {
            font-weight: 700;
            font-size: 28px;
            line-height: 1.5;
            margin: 0 auto;
        }

        h4 {
            font-weight: 700;
            font-size: 18px;
            line-height: 1.5;
            margin: 10px auto;
        }

        .v-avatar {
            font-size: 20px;
            line-height: 20px;
        }

        @media (max-width: 1024px) {
            width: 100%;
            padding-left: 20px;
            padding-right: 20px;
        }
    }

    &.section-dark {
        background-color: #373e55;

        .content {
            h2, h3, h4, p {
                color: #FFFFFF;
            }
        }
    }
}

/** About section styles */
div.about-section {
    .about-block {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 80px !important;

        .about-text {
            flex: 0 1 44.1%;
            text-align: left;
            margin: auto 0;
            padding-top: 0;

            h4 {
                max-width: 610px;
                font-size: 26px;
                font-weight: 700;
                line-height: 1.60;
                margin: 0 auto 43px;
            }

            p {
                max-width: 610px;
                font-size: 16px;
                font-weight: 400;
                line-height: 1.60;
                margin: 0 auto;
                word-spacing: normal;
            }
        }

        .about-image {
            display: flex;
            flex: 0 1 49%;
            padding-right: 10px;
            justify-content: center;
            padding-top: 20px;
            padding-bottom: 50px;

            img {
                width: 100%;
                box-shadow: 0 6px 6px rgba(0, 0, 0, 0.25);
                border-radius: 15px;
            }

            @media (max-width: 1400px) {
                margin: auto;
            }
        }

        @media (max-width: 1024px) {
            justify-content: center;
            margin-top: 0 !important;

            .about-text,
            .about-image {
                justify-content: center;
                flex: 0 1 100%;
                padding: 15px;
            }
        }

        @media (max-width: 960px) {
            .about-text,
            .about-image {
                text-align: center;
            }

            .about-text {
                h4, p {
                    max-width: 100%;
                }
            }
        }
    }

    .about-block + .about-block {
        margin-top: 0 !important;
    }

    @media (max-width: 768px) {
        padding: 50px 0;

        .about-block {
            .about-text,
            .about-image {
                flex: 0 0 100%;
                width: 100% !important;
                max-width: 100% !important;
            }
        }
    }
}

/** Steps section styles */
div.steps-section .step-block {
    .step-image img {
        max-width: 100%;
        height: auto;
        border-radius: 20px;
    }

    .step-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .content-container {
            width: 90%;
            margin: 0 auto;

            p {
                text-align: left;
                padding: 20px 15px 15px;
                background-color: #2d76e3;
                border-radius: 5px;
            }

            .content-line {
                width: 25%;
                margin-left: auto;
                border-bottom: 5px solid #2d76e3;
                border-radius: 5px;
                position: relative;
                left: 20%;
                top: 50%;

                @media (max-width: 1650px) {
                    width: 15%;
                    left: 12.5%;
                }

                @media (max-width: 1550px) {
                    width: 10%;
                    left: 7.5%;
                }

                @media (max-width: 1475px) {
                    display: none;
                }
            }

            .step-avatar {
                position: relative;
                bottom: calc(100% + 36px);
                left: -36px;

                .v-avatar {
                    font-size: 26px;
                    line-height: 26px;
                    border: 3px solid #FFFFFF !important;
                    position: absolute;
                }
            }
        }
    }

    &.flex-row-reverse {
        .step-content .content-container .content-line {
            margin-left: 0;
            left: -20%;

            @media (max-width: 1650px) {
                left: -12.5%;
            }

            @media (max-width: 1550px) {
                left: -7.5%;
            }
        }

        @media (max-width: 1024px) {
            flex-direction: row !important;
        }
    }

    @media (max-width: 960px) {
        .step-image img {
            width: 100%;
        }

        .step-content .content-container {
            width: 100%;
            margin: 0;
        }

        .spacer {
            display: none;
        }
    }

    @media (max-width: 768px) {
        .step-image {
            flex: 0 0 100%;
            width: 100% !important;
            max-width: 100% !important;
        }

        .step-content {
            flex: 0 0 100%;
            width: 100% !important;
            max-width: 100% !important;
        }
    }
}

/** Testimonials section styles */
div.testimonials-section {
    .school-carousel {
        margin-top: 100px !important;
        min-height: 72px;
        position: relative;
        opacity: 0.5;

        ::v-deep .logo-marquee {
            position: absolute;
            background-color: #FFFFFF;

            img {
                filter: invert(50%);
            }
        }

        @media (max-width: 1024px) {
            margin-top: 48px !important;
        }
    }

    ::v-deep .steps-content {
        margin-top: 65px;

        p {
            width: auto;
            max-width: 325px;
        }

        img {
            width: auto;
        }
    }

}

/** Call to Action section styles */
div.call-to-action {
    font-family: 'Poppins';
    font-style: normal;
    padding: 100px 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    max-height: 1005px;
    min-height: 735px;
    background-image: url("../../src/assets/media/area-guide-footer.png");
    background-position: top center;
    background-size: cover;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    overflow: hidden;

    @media (max-width: 450px) {
        max-height: 10205px;
    }

    .call-to-action-content {
        padding: 0;

        h2 {
            font-weight: 700;
            font-size: 48px;
            line-height: 1.5;
            margin: 0 auto;
            color: #FFFFFF;
        }

        p {
            font-weight: 400;
            font-size: 16px;
            line-height: 26px;
        }
    }

    .call-to-action-form {
        padding: 15px;
        border-radius: 15px;
        background-color: #e3e4e5;

        h3 {
            font-size: 26px;
            @media (max-width: 450px) {
                font-size: 23px;
            }
        }


        label {
            font-weight: 700;
            font-size: 13px;
            letter-spacing: 0;
            color: #000000;
        }

        .v-input, .v-btn {
            height: 46px;
        }
    }

    &:before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(10, 10, 10, 0.75);
        z-index: 1;
    }

    @media (max-width: 1400px) {
        background-size: cover !important;
    }

    @media (max-width: 1024px) {
        padding: 75px 0;
    }

    @media (max-width: 768px) {
        padding: 50px 0;
    }

    @media (max-width: 655px) {
        padding: 0;
    }
}

/** Generic Responsive styles */
@media (max-width: 1024px) {
    div.hero-banner .container,
    div.call-to-action .content {
        margin-top: auto;
        margin-bottom: auto;
        height: 100%;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }
}

@media (max-width: 768px) {
    div.hero-banner .container,
    div.section .content {
        max-width: 100%;
    }
}
</style>
